import { IconAIStar, IconAIVoiceAgent } from '@/assets/static/icons';
import { ROLE_MAPS } from '@shared/constants/roles';
import { Button } from 'antd';
import { RiContactsBookLine, RiDashboardLine, RiSettings3Fill, RiSurveyLine } from 'react-icons/ri';
import { TbLayoutGridAdd } from 'react-icons/tb';
import { SidebarItemType } from './sidebar.types';
import { TFunction } from 'i18next';
import { capitalize } from '@shared/utils/capitalize';
import { hasRoleAccess } from '@shared/utils/roles/has-role-access.helper';
import { PLAN_MAPS } from '@shared/constants/plans';
import { BULK_MESSAGING_BASE_PATH } from '@modules/bulk-messaging/bulk-messaging.constants';
import { CgBolt } from 'react-icons/cg';

type SidebarItemTypeII = SidebarItemType & {
  external?: string;
};

const extraAnalyticMenu = (t: TFunction) => (
  <div className="flex items-center justify-center">
    <Button className="text-primary-500! text-[10px]! uppercase h-5! rounded-full! px-2.5! py-0.5! pointer-events-none! grow-0! tracking-wider">
      {t('ai_beta')}
    </Button>
  </div>
);

const extraNewBadge = (t: TFunction) => (
  <div className="flex items-center justify-center">
    <Button className="text-primary-500! text-[10px]! uppercase h-5! rounded-full! px-2.5! py-0.5! pointer-events-none! grow-0! tracking-wider">
      {t('new')}
    </Button>
  </div>
);

const toolsLandingPath = () =>
  hasRoleAccess(ROLE_MAPS.BULK_MESSAGING_CAMPAIGNS_VIEW)[0] ? BULK_MESSAGING_BASE_PATH : '/tools/download-apps';

export const items = (t: TFunction): SidebarItemTypeII[] => [
  {
    key: '/dashboard',
    icon: <RiDashboardLine className="size-6" data-tour-id="dashboard" />,
    label: capitalize(t('dashboard')),
  },
  {
    key: '/analytics/ai-dashboard',
    mobileKey: '/analytics',
    icon: <RiSurveyLine className="size-6" data-tour-id="analytics" />,
    label: (
      <span className="flex">
        {capitalize(t('analytics'))}
        <IconAIStar className="w-3.25! h-[15px]!" />
      </span>
    ),
    planPrivilege: PLAN_MAPS.AI_DASHBOARD_AI_REPORT_ANALYTICS_VIEW,
    extra: extraAnalyticMenu(t),
  },
  {
    key: '/ai-assistance/ai-voice-agent',
    mobileKey: '/ai-assistance',
    icon: <IconAIVoiceAgent className="size-6" data-tour-id="ai_assistance" />,
    label: capitalize(t('ai_assistance')),
    extra: extraAnalyticMenu(t),
  },
  {
    key: '/contacts',
    icon: <RiContactsBookLine className="size-6" data-tour-id="contacts" />,
    label: capitalize(t('contact', { count: 5 })),
    rolePrivilege: ROLE_MAPS.CONTACTS_CONTACTS_LIST,
  },
  {
    key: toolsLandingPath(),
    mobileKey: '/tools',
    icon: <TbLayoutGridAdd className="size-6 rotate-270" data-tour-id="tools" />,
    label: capitalize(t('tools')),
    extra: extraNewBadge(t),
  },
  {
    key: '/calilio-hub/overview',
    mobileKey: '/calilio-hub',
    icon: <CgBolt className="text-primary-400! border border-gray-800 rounded-full" />,
    label: capitalize(t('calilio_hub')),
  },
  {
    key: '/settings/my-profile',
    mobileKey: '/settings',
    icon: <RiSettings3Fill className="size-6" data-test-id="settings" data-tour-id="settings" />,
    label: capitalize(t('settings')),
  },
];
